import React from 'react'
import underGroundCont from '../assets/foreground-underground-continuation.png'
import '../index.css'
import CPIntro from './CPIntro'
import Mint from './Mint'
import MintOtherSideGems from './MintOtherSideGems'
import MintSideGems from './MintSideGems'
import eegDip1 from '../assets/eegg-dip1-dirty.png'
import Utility from './Utility'
import BottomGemsBlock from './BottomGemsBlock'
import Rarity from './Rarity'
import Team from './Team'
import End from './End'
import Footer from './Footer'



function Underground() {
  return (
    <div className='CPIntro relative bottom-0 top-0 '>
        <div className="  ">
    
       <div className="underContainer absolute w-full text-center ">
       <div className="underTitle relative top-5 text-white font-title text-[8px] sm:text-[10px] lg:text-[40px] mb-12 ">
        MINT YOUR COIN PLANT!
        </div>
        <div className="mintWrapper w-full flex justify-center mt-10    ">
        <MintSideGems/>
        <Mint/>
        <MintOtherSideGems/>
        </div>

        <CPIntro/>
        
        <div className=" hidden wrapperImgCenter CPIntroBelow lg:flex justify-center ">
        <img className="w-20 rounded-[2rem] object-contain  absolute top-[1510px] right-[400px] -rotate-45  " src={eegDip1} alt="" />
        </div>
        

        <Utility/>
        {/* <BottomGemsBlock/> */}
        <Rarity/>
        <Team/>
        {/* <End/> */}
      {/* <Footer/> */}

       </div>

        </div>
    </div>
  )
}

export default Underground